import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
    const { user, loading, teamRoles, allTeams, warehouseId } = useAuth();
    const location = useLocation();

    if (loading) return <div>جاري التحميل...</div>;

    // Allow access to choose-warehouse
    if (location.pathname === '/choose-warehouse') {
        return children;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Force warehouse selection if not selected and multiple available
    if (!warehouseId && allTeams && allTeams.length > 1) {
        return <Navigate to="/choose-warehouse" replace />;
    }

    // Role-Based Access Control
    if (user.labels && user.labels.includes('production')) {
        const allowedPaths = ['/production', '/production-records'];
        if (!allowedPaths.includes(location.pathname)) {
            return <Navigate to="/production" replace />;
        }
    }

    // Owner-only: Permissions Management
    if (location.pathname === '/permissions') {
        if (!teamRoles || !teamRoles.includes('owner')) {
            return <Navigate to="/home" replace />;
        }
    }

    // Sales Only Restriction
    if (teamRoles && teamRoles.includes('salesOnly')) {
        const allowedPaths = ['/sales-home', '/sales-daily', '/sales-monthly', '/sales-previous', '/sales-items'];
        if (!allowedPaths.includes(location.pathname)) {
            return <Navigate to="/sales-home" replace />;
        }
    }

    if (user.labels && user.labels.includes('manger')) {
        if (location.pathname === '/items') {
            return <Navigate to="/home" replace />;
        }
    }

    return children;
};
